import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export function HeartBeatTooltipContent({ updatedAt }: { updatedAt: number }) {
  return (
    <div className='p-1' data-id='hevo-heartbeat-tooltip-content'>
      <div className='d-flex'>
        <div className='flex-col'>
          <p className='text-subheading-3 text-medium'>{dayjs(updatedAt).fromNow()}</p>
        </div>
      </div>

      <p className='py-1 mt-1'>Last heartbeat received</p>
    </div>
  );
}
